export interface LoyaltyLandingPageTileDetails {
  title: string;
  description: string;
  image: App.Image;
}

export const loyaltyLandingPageBenefitTiles = {
  upgrades: {
    title: 'Elevate your stay with free room upgrades',
    description: 'Enjoy complimentary room upgrades on select offers. Your upgrade is guaranteed as soon as you book, ensuring a seamless check-in with no surprises.',
    image: {
      id: 'wfzka1j5ru5d5e7hc9u',
      title: 'Free room upgrades',
    },
  },
  transfers: {
    title: 'Start your escape with chauffeur transfers',
    description: 'Luxury begins the moment you step out your door with a private chauffeur-driven ride to the airport.',
    image: {
      id: '0qt5tc9nvf1qd3f0t5fe',
      title: 'Free airport chauffeur service',
    },
  },
  lounge: {
    title: 'Lounge in comfort before your flight',
    description: 'Unwind with a drink, a bite to eat, and a quiet space to relax, the perfect start to your Luxury Escape.',
    image: {
      id: 'rq13k5lzgr8oxoz3a2',
      title: 'Free airport lounge passes',
    },
  },
  support: {
    title: 'Priority support',
    description: 'Skip the queue with 24/7 access to our dedicated support team, always here to help, whenever you need us.',
    image: {
      id: 'kf3r6fahlubu2yb1htkgb',
      title: 'Faster, priority support',
    },
  },
  travelshoot: {
    title: 'Discounted photoshoots',
    description: 'Capture your escape in style with exclusive discounts on professional Travelshoot photo sessions at your destination.',
    image: {
      id: 'r1z816jjifeqb5hwk50o',
      title: 'Pro photos on your trip',
    },
  },
  tourExtras: {
    title: 'Extras on your tour',
    description: 'Unlock credits for exclusive add-ons, from relaxing massages to local food experiences.',
    image: {
      id: '69vg83q7obl8xw4x1ac',
      title: 'Extras on your tour',
    },
  },
}
